const readOptions = [
  {
    label: '未读',
    value: 0
  },
  {
    label: '已读',
    value: 1
  }
]
const sendOptions = [
  {
    label: '全部发送状态',
    value: null
  },
  {
    label: '发送失败',
    value: 0
  },
  {
    label: '发送成功',
    value: 1
  }
]
const roleOptions = [
  {
    label: '全部角色',
    value: null
  },
  {
    label: '系统',
    value: 0
  },
  {
    label: '患者',
    value: 1
  },
  {
    label: '医生',
    value: 2
  },
  {
    label: 'BD',
    value: 3
  },
  {
    label: '健管',
    value: 4
  },
  {
    label: '合作医院',
    value: 5
  },
  {
    label: 'cms',
    value: 6
  },
  {
    label: '医生学生',
    value: 7
  }
]

// 根据角色值 查询角色名称
const roleName = val => {
  const role = roleOptions.find(f => f.value === val)
  return role.label
}
const columns = [
  {
    title: '发送人',
    dataIndex: 'sendPerson',
    key: 'sendPerson',
    width: 120,
    slots: { customRender: 'sendPerson' }
  },
  {
    title: '接收人',
    dataIndex: 'receivePerson',
    key: 'receivePerson',
    width: 120,
    slots: { customRender: 'receivePerson' }
  },
  {
    title: '发送时间',
    width: 120,
    dataIndex: 'sendTime',
    key: 'sendTime'
  },
  {
    title: '发送状态',
    width: 90,
    dataIndex: 'sendStatus',
    key: 'sendStatus',
    slots: { customRender: 'sendStatus' }
  },
  {
    title: '触达状态',
    dataIndex: 'reachStatusDesc',
    key: 'reachStatusDesc',
    width: 90
  },
  {
    title: '已读情况',
    width: 90,
    dataIndex: 'readStatusDesc',
    key: 'readStatusDesc'
  },
  {
    title: '发送类型',
    dataIndex: 'sendTypeSnapshot',
    width: 200,
    key: 'sendTypeSnapshot'
  },
  {
    title: '关联工单',
    dataIndex: 'mainRelatedWorkOrder',
    width: 200,
    key: 'mainRelatedWorkOrder',
    slots: { customRender: 'mainRelatedWorkOrder' }
  },
  {
    title: '短信详情',
    dataIndex: 'smsInfo',
    key: 'smsInfo',
    width: 300,
    slots: { customRender: 'smsInfo' }
    // ellipsis: true
  }
]

export { readOptions, sendOptions, roleOptions, roleName, columns }
